import React, { useState, useEffect } from "react";
import {
  db,
  collection,
  onSnapshot,
  query,
  where,
  doc,
  ref,
  getDownloadURL,
  uploadBytesResumable,
  updateDoc,
  storage,
  deleteDoc,
} from "../../config/firebase";
import { Avatar, Select, Table, Button, Modal, Input } from "antd";
import Swal from "sweetalert2";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faDownload } from "@fortawesome/free-solid-svg-icons";
import { Chip } from "@material-tailwind/react";
import { GetFullDate } from "../../utils/date.methods";
import moment from "moment/moment";
// import { PDFDownloadLink } from '@react-pdf/renderer';
// import PdfDocument from '../generateInvoice/Invoice';
// import MyDocument from './MyDocument'

const RegStdCom = ({ statusFilter, searchQuery, course, batch }) => {
  const [editingUser, setEditingUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [phoneCounts, setPhoneCounts] = useState({});
  // const [pdfData, setPdfData] = useState(null);

  // const generatePdf = (record) => {
  //   console.log(pdfData);
  //   setPdfData(record);
  // };
  const handleEdit = (record) => {
    setEditingUser(record);
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    });

    if (result.isConfirmed) {
      const washingtonRef = doc(db, "Students", id);
      await deleteDoc(washingtonRef);
      alert("Deleted");
    }
  };
  useEffect(() => {
    if (statusFilter) {
      const q = query(
        collection(db, "Students"),
        where("status", "==", statusFilter)
      );
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const updatedData = [];
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added" || change.type === "modified") {
            updatedData.push(change.doc.data());
          }
          if (change.type === "removed") {
            // Handle removed data if needed
          }
        });

        setFilteredData(updatedData);
      });
      return () => unsubscribe();
    } else if (course) {
      const q = query(collection(db, "Students"), where("course", "==", course));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const updatedData = [];
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added" || change.type === "modified") {
            updatedData.push(change.doc.data());
          }
          if (change.type === "removed") {
          }
        });

        setFilteredData(updatedData);
      });
      return () => unsubscribe();
    } else if (batch) {
      const q = query(collection(db, "Students"), where("batch", "==", batch));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const updatedData = [];
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added" || change.type === "modified") {
            updatedData.push(change.doc.data());
          }
          if (change.type === "removed") {
          }
        });
        setFilteredData(updatedData);
      });
      return () => unsubscribe();
    }
  }, [course, statusFilter, batch]);

  const handleSave = async () => {
    if (!editingUser) return;

    try {
      if (editingUser.picFile) {
        // Create a reference to the Firebase Storage location
        const storageRef = ref(storage, `images/${editingUser.key}`);

        // Upload the file to Firebase Storage
        const uploadTask = uploadBytesResumable(
          storageRef,
          editingUser.picFile
        );
        uploadTask.on(
          "state_changed",
          (snapshot) => {},
          (error) => {
            console.error("Upload failed with error:", error);
          },
          () => {
            // When the upload is complete, get the download URL
            getDownloadURL(uploadTask.snapshot.ref)
              .then((picUrl) => {
                const washingtonRef = doc(db, "Students", editingUser.key);
                // Update the Firestore document with the download URL
                updateDoc(washingtonRef, {
                  ...editingUser,
                  pic: picUrl,
                  picFile: null, // Clear the picFile field
                })
                  .then(() => {
                    setIsModalVisible(false);
                    setEditingUser(null);
                    alert("Updated");
                  })
                  .catch((error) => {
                    console.error("Error updating Firestore document:", error);
                  });
              })
              .catch((error) => {
                console.error("Error getting download URL:", error);
              });
          }
        );
      } else {
        // No new picture selected, update user document without changing the pic property
        const washingtonRef = doc(db, "Students", editingUser.key);
        updateDoc(washingtonRef, { ...editingUser })
          .then(() => {
            setIsModalVisible(false);
            setEditingUser(null);
            alert("Updated");
          })
          .catch((error) => {
            console.error("Error updating Firestore document:", error);
          });
      }
    } catch (error) {
      console.error("Error updating profile picture:", error);
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "pic",
      render: (pic, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            style={{
              width: "55px",
              height: "55px",
              border: `2px solid ${
                record.status === "Approved" ? "green" : "#ff6f00"
              }`,
            }}
            alt="avatar"
            src={pic}
          />
          <div style={{ marginLeft: "30px" }}>
            <p>{record.name}</p>
            <p>
              {" "}
              <b> {record.rollNumber} </b>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text, record) => (
        <span style={{ color: phoneCounts[text] > 1 ? "red" : "inherit" }}>
          {text}
        </span>
      ),
    },
    // {
    //   title: "Batch",
    //   dataIndex: "batch",
    // },
   
    {
      title: "Course",
      dataIndex: "course",
    },
    {
      title: "Batch",
      dataIndex: "batch",
    },
    {
      title: "Date",
      dataIndex: "submitDate",
      render: (val) => GetFullDate(val) || "Invalid Date",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <div className="w-max">
          <Chip
            size="sm"
            variant="ghost"
            value={text}
            color={
              text === "Approved"
                ? "green"
                : text === "Pending"
                ? "amber"
                : "amber"
            }
          />
        </div>
        
      ),
    },
    
    {
      title: "Actions",
      render: (text, record) => (
        <div>
          <Button
            onClick={() => handleEdit(record)}
            style={{ marginRight: "10px" }}
          >
            <FontAwesomeIcon
              icon={faEdit}
              style={{ color: "#ccc", marginRight: "10px" }}
            />
            Edit
          </Button>
          <Button onClick={() => handleDelete(record.key)}>
            <FontAwesomeIcon
              icon={faTrash}
              style={{ color: "#ccc", marginRight: "10px" }}
            />
            Delete
          </Button>
        </div>
      ),
    },
    // {
    //   title: 'Download PDF',
    //   render: (text, record) => (

    //      <>
    //       <Button
    //     className="flex justify-center border-2 items-center"
    //     onClick={()=>{
    //       handlePic(record.pic,"jpeg")
    //     }}
    //   >

    //     <FontAwesomeIcon
    //       icon={faDownload}
    //       style={{ color: "#ccc", marginRight: "10px" }}
    //       size="md"

    //     />
    //     Download PDF
    //   </Button>

    //   {record && (
    //     <PDFDownloadLink
    //       document={<PdfDocument invoicedata={record} />
    //     }
    //       fileName={`${record.name}.pdf`}
    //     >
    //       {({ blob, url, loading, error }) =>
    //         loading ? 'Loading document...' :<Button  className="flex justify-center border-2 items-center  download-button"  > <FontAwesomeIcon  icon={faDownload} style={{ color: "white", marginRight: "10px" }}  shake size="lg" />Download ID Card</Button>
    //       }
    //     </PDFDownloadLink>
    //   )}

    //      </>

    //   ),
    // },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={filteredData} />
      <Modal
        title="Edit User"
        visible={isModalVisible}
        onOk={handleSave}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingUser(null);
        }}
        className="custom-modal"
        cancelButtonProps={{
          style: { backgroundColor: "white", color: "#ccc" },
        }}
        okButtonProps={{ type: "dashed" }}
      >
        {editingUser && (
          <form className="custom-form">
            {[
              "name",
              "fname",
              "cnic",
              "phone",
              "email",
              "dob",
              "address",
              "qualification",
            ].map((field) => (
              <div className="input-container" key={field}>
                <label htmlFor={field}>
                  {field === "name" ? "First Name" : field}:
                </label>
                <Input
                  id={field}
                  type={field === "dob" ? "date" : "text"}
                  placeholder={field === "name" ? "First Name" : field}
                  value={editingUser[field]}
                  onChange={(e) =>
                    setEditingUser({ ...editingUser, [field]: e.target.value })
                  }
                />
              </div>
            ))}
            <div className="input-container">
              <label htmlFor="gender">Gender:</label>
              <Select
                defaultValue={editingUser.gender}
                onChange={(value) =>
                  setEditingUser({ ...editingUser, gender: value })
                }
                style={{ width: 120 }}
                options={[
                  { value: "Male", label: "Male" },
                  { value: "Female", label: "Female" },
                ]}
              />
            </div>
            <div className="input-container">
              <label htmlFor="pic">Profile Picture:</label>
              <input
                id="pic"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  console.log(file);

                  if (file) {
                    setEditingUser({
                      ...editingUser,
                      pic: file,
                      picFile: file,
                    });
                  }
                }}
              />
            </div>
          </form>
        )}
      </Modal>
    </div>
  );
};

export default RegStdCom;
